export function isLeft(either) {
    return either._tag === "Left";
}
/**
 * Human-friendly alias for `isLeft`.
 */
export const isError = isLeft;
export function isRight(either) {
    return either._tag === "Right";
}
/**
 * Human-friendly alias for `isRight`.
 */
export const isValid = isRight;
export function left(e) {
    return { _tag: "Left", left: e };
}
export function right(a) {
    return { _tag: "Right", right: a };
}
export function getOrThrow(maybe) {
    if (isLeft(maybe))
        throw maybe.left;
    return maybe.right;
}
